import axios from "axios";

const ENV_BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const sameHost = (u) => { try { return new URL(u).host === window.location.host; } catch { return false; } };
// Stay same-origin (e.g. www vs apex domain) so auth headers are never dropped by a cross-origin redirect
export const BACKEND = !ENV_BACKEND || sameHost(ENV_BACKEND) || window.location.hostname === "localhost" ? ENV_BACKEND : window.location.origin;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("mroue_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const media = (u) => (u ? (u.startsWith("http") ? u : `${BACKEND}${u}`) : "");

export const srcSet = (p) => {
  const v = p?.variants || {};
  return ["thumb", "medium"]
    .filter((k) => v[k] && p?.urls?.[k])
    .map((k) => `${media(p.urls[k])} ${v[k].width}w`)
    .join(", ");
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.message || JSON.stringify(d);
};

export const fmtBytes = (b = 0) => {
  if (b < 1024) return `${b} B`;
  const u = ["KB", "MB", "GB", "TB"];
  let i = -1;
  do { b /= 1024; i++; } while (b >= 1024 && i < u.length - 1);
  return `${b.toFixed(b < 10 ? 2 : 1)} ${u[i]}`;
};

export const CATEGORIES = ["wildlife", "landscape", "underwater", "people-culture", "travel"];
export const BLOG_CATEGORIES = ["wildlife-stories", "travel-journals", "behind-the-lens", "photography-techniques", "equipment-reviews", "conservation-and-nature"];
